import { render } from "./Procedures.vue?vue&type=template&id=57af3d56&scoped=true"
import script from "./Procedures.vue?vue&type=script&lang=js"
export * from "./Procedures.vue?vue&type=script&lang=js"

import "./Procedures.vue?vue&type=style&index=0&id=57af3d56&scoped=true&lang=css"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57af3d56"]])

export default __exports__